import script from "./propose-amendment-button.vue?vue&type=script&lang=js"
export * from "./propose-amendment-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__